import { blogService } from '../services/blogService';

// 初始化博客数据
export const initializeBlogData = async () => {
  // 检查是否已有博客数据，如果没有则进行初始化
  try {
    const existingPosts = await blogService.getAllPosts();
    if (existingPosts.length === 0) {
      console.log('博客系统已初始化，等待内容添加');
    } else {
      console.log(`博客系统已加载，当前有 ${existingPosts.length} 篇文章`);
    }
  } catch (error) {
    console.error('初始化博客数据失败:', error);
  }
};